import ContractorCard from '../../Molecules/Cards/ContractorCard';
import bem from '../../../utils/bem';
import Button from '../../Atoms/Button';

const ContinueSearch = ({
  contractors,
  title,
  zipCode,
  productCategory,
  total,
  isFap,
  mods,
  extra,
  maxRadius,
  onCtaClick,
}) => {
  if (!contractors || !contractors.length) return null;
  const componentBaseClass = 'continue-search';

  const subTitle = Drupal.t(
    'Results within @maxRadius of @zipCode for @productCategory (previewing 2 of @total):',
    {
      '@maxRadius': maxRadius,
      '@zipCode': zipCode,
      '@productCategory': productCategory,
      '@total': total,
    },
  );

  const contractorsList = contractors.map(
    (contractor) =>
      contractor && (
        <ContractorCard
          contractorData={contractor}
          key={contractor.id}
          className={
            isFap
              ? bem('card', [], componentBaseClass)
              : 'm-contractor-card--distributor'
          }
          showDefaultImage={isFap}
          isSmall
        />
      ),
  );

  return (
    <div className={bem(componentBaseClass, mods, '', extra)}>
      <h2
        className={bem('title', [], componentBaseClass, [
          'h',
          'h3',
          'text-blue',
        ])}
      >
        {Drupal.t(title)}
      </h2>
      <h3 className={bem('sub-title', [], componentBaseClass, ['h', 'h5'])}>
        {subTitle}
      </h3>
      {contractors.length && (
        <div
          className={bem('contractors', [], componentBaseClass, [
            'flex',
            'flex-wrap',
          ])}
        >
          {contractorsList}
        </div>
      )}
      <div className={bem('see-all', [], componentBaseClass)}>
        <Button
          mods={['secondary', 'blue', 'm']}
          onClick={() => onCtaClick?.()}
          extra={bem('all-results-btn', [], componentBaseClass)}
        >
          {Drupal.t('See all results for @maxRadius', {
            '@maxRadius': maxRadius,
          })}
        </Button>
      </div>
    </div>
  );
};

export default ContinueSearch;
